import { styled } from 'styled-components/native';

interface SectionContentProps {
  flexDirection?: 'row' | 'column';
}

export const SectionContent = styled.View<SectionContentProps>`
  margin-bottom: 24px;
  display: flex;
  flex-direction: ${props => props.flexDirection || 'row'};
  justify-content: flex-start;
  gap: 16px;
`;

